// extracted by mini-css-extract-plugin
export default {"disabled":"TrapPlotsComponent_disabled__xBhtV","pheromone":"TrapPlotsComponent_pheromone__vwkI1","paper":"TrapPlotsComponent_paper__r+DnR"};